<template>
  <div v-if="loading">
    <sdCards headless>
      <div class="spin">
        <a-spin />
      </div>
    </sdCards>
  </div>
  <div v-else>
    <sdPageHeader title="All Banks Connected">
      <template v-slot:subTitle>
        <div class="bank-header-meta">
          <a-button
            size="default"
            type="text"
            style="
              border: none;
              vertical-align: middle;
              transform: rotateZ(270deg);
            "
          >
            <span>
              <sdFeatherIcons
                style="line-height: 0; color: black !important"
                type="bar-chart"
                size="18"
            /></span>

          </a-button>
          <span class="bank-header-meta__label">Plaid remains unchanged. Use Yapily and TrueLayer as separate additional connection flows.</span>
        </div>
       </template>
      <template v-slot:buttons>
        <div class="page-header-actions banking-header-actions">
          <a-button type="default" class="banking-header-actions__button" @click="openYapilyBanking">
            Connect With Yapily
          </a-button>
          <a-button type="primary" class="banking-header-actions__button banking-header-actions__button--primary" @click="openTrueLayerBanking">
            Connect With TrueLayer
          </a-button>
        </div>
      </template>

    </sdPageHeader>
     
    <Main>
    
      <div v-if="empty">
        <sdCards headless>
          <div class="spin">
            <a-spin />
          </div>
        </sdCards>
      </div>
      <div v-else>
        <a-row :gutter="25">
          <a-col :md="24">
            <div headless v-if="empty">
              <div v-if="loading">
                <sdCards headless>
                  <div class="spin">
                    <a-spin />
                  </div>
                </sdCards>
              </div>
            </div>
            <div headless v-else>
              <a-list
                style="margin: 0px"
                class="demo-loadmore-list"
                item-layout="horizontal"
                :data-source="usersTableData"
              >
                <template #renderItem="{ item }">
                  <ProductCard
                    class="list-view"
                    :style="{ marginBottom: '20px' }"
                  >
                    <div class="product-list" style="padding: 10px">
                      <a-row :gutter="15">
                        <a-col :md="2" :xs="24">
                          <figure style="margin-left: 20px">
                            <img
                              :style="{ width: '40px' }"
                              :src="
                                require('@/static/img/auth/Illustration.png')
                              "
                              alt=""
                            />
                          </figure>
                        </a-col>
                        <a-col
                          :md="13"
                          :xs="24"
                          v-on:click="overviewpage(item.account_id)"
                        >
                          <div class="product-single-description">
                            <sdHeading
                              class="product-single-title"
                              as="h2"
                              style="margin: 0px; font-size: 16px"
                            >
                              {{ item.name }}
                            </sdHeading>
                            <p style="margin: 0px; font-size: 14px">
                              Official Name:
                              {{
                                item.official_name
                              }}
                            </p>
                            <p style="margin: 0px; font-size: 14px">
                              Type:
                              {{
                                item.type
                              }}&nbsp;&nbsp;
                              SubType:
                              {{
                                item.subtype
                              }}
                            </p>
                          </div>
                          
                        </a-col>
                        
                        
                      </a-row>
                    </div>
                  </ProductCard>
                </template>
              </a-list>
            </div>
          </a-col>
       </a-row>
       
       </div>

    </Main>
  </div>
</template>
<script>
import { Main, TableWrapper } from "../styled";
import { computed, ref, defineComponent, onMounted,reactive } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import { UserTableStyleWrapper, Action, ProductCard } from "./style";
import * as FontAwesomeIcon from "@fortawesome/free-solid-svg-icons";
import Modal from "/src/components/Modal.vue";
import HalfProgressBar from "/src/components/utilities/progressBar.vue";
import { message, Notification } from 'ant-design-vue';

export default defineComponent({
  name: "dashboard",
  components: {
    Main,
    TableWrapper,
    UserTableStyleWrapper,
    Modal,
    HalfProgressBar,
    ProductCard,
    FontAwesomeIcon,
    Action,
    
  },
 
  setup() {
    let empty = ref(true);
    let loading = ref(true);
    var counts =ref(null);
    var counts1 =ref(null);
    let reconnect=ref(false);
    var msg = "";
    const param = useRoute();
    const router = useRouter();
    const { state, dispatch } = useStore();
    const API_ENDPOINT = process.env.VUE_APP_API_ENDPOINT;
    onMounted(() => {
      xerocheck();
    });
    const xerocheck = () => {
    localStorage.removeItem("search_data");
    localStorage.removeItem("filter_data");
    localStorage.removeItem("users_details");
      dispatch("getmainclientlist").then(
          (response) => {
            state.xeroclient.data = response.data;
            //counts.value = response.data[0].total_clients_connected;
            //counts1.value = response.data[0].total_subclients;
            empty.value = false;
            loading.value = false;
          },
          (error) => {
            empty.value = false;
            loading.value = false;
          }
        );
    };
    const rowSelection = {
      onChange: (selectedRowKeys, selectedRows) => {
        selectedRowKeys.value = selectedRowKeys;
        selectedRows.value = selectedRows;
      },
      getCheckboxProps: (record) => ({
        disabled: record.name === "Disabled User",
        name: record.name,
      }),
    };
    const overviewpage = (id) => {
      if (id !== undefined) {
        localStorage.setItem("bank_account_id", id);
        router.push({ path: "/transactions" });
      }
    };

    const openYapilyBanking = () => {
      router.push({ path: "/banking" });
    };

    const openTrueLayerBanking = () => {
      router.push({ path: "/truelayer" });
    };
  
  
    var usersTableData = computed(() => state.xeroclient.data);

    return {
      rowSelection,
      empty,
      usersTableData,
      overviewpage,
      openYapilyBanking,
      openTrueLayerBanking,
      loading,
      counts,
      counts1,
      
    };
  },
});
</script>
<style>
.ant-list-items {
  padding-top: 0px !important;
}

.highlighted {
  margin: 10px !important;
  border-spacing: 0 8px !important;
}

.product-list:hover {
  -webkit-box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);
  -moz-box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);
  cursor: pointer;
}

.bank-header-meta {
  display: flex;
  align-items: center;
  gap: 8px;
}

.bank-header-meta__label {
  color: #6b7280;
  font-size: 14px;
}

.banking-header-actions {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
}

.banking-header-actions__button {
  border-color: #0f766e;
  color: #0f766e;
}

.banking-header-actions__button--primary {
  border-color: transparent;
  color: #ffffff;
  background: linear-gradient(135deg, #0f766e 0%, #155eef 100%);
}

.banking-header-actions__button:hover,
.banking-header-actions__button:focus {
  border-color: #115e59;
  color: #115e59;
}

.banking-header-actions__button--primary:hover,
.banking-header-actions__button--primary:focus {
  border-color: transparent;
  color: #ffffff;
}
</style>